/** @format */

import {
	Component,
	computed,
	inject,
	viewChild,
	ChangeDetectionStrategy,
	effect
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HmfSnackbarComponent } from '@dsg-tech/homefield-angular';
import { BreakPointNew } from '@shared/data-access/enums';
import { AppSnackbarService } from '@pdp/data-access/services';
import { BreakpointsService } from '@shared/data-access/services';

@Component({
	selector: 'pdp-component-app-snackbar',
	imports: [CommonModule, HmfSnackbarComponent],
	templateUrl: './app-snackbar.component.html',
	styleUrl: './app-snackbar.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppSnackbarComponent {
	private readonly breakpointsService = inject(BreakpointsService);
	snackbarService = inject(AppSnackbarService);

	readonly snackBarComponent = viewChild.required<HmfSnackbarComponent>('snackbar');
	readonly isMobile = computed(() => this.breakpointsService.breakpoint() <= BreakPointNew.SMALL);
	readonly offset = computed(() => (this.isMobile() ? 'large' : 'medium'));
	readonly zIndex = computed(() =>
		this.snackbarService.options()?.showAboveDrawers ? 999998 : 5
	);

	constructor() {
		effect(() => {
			if (this.snackBarComponent()) {
				this.snackbarService.register(this.snackBarComponent());
			}
		});
	}
}
